import { atom } from 'recoil';
import { taxConsentState } from './taxConsentState';

const previousPageState = atom({
    key: 'previousPageState',
    default: null,
});

const userState = atom({
    key: 'userState',
    default: {},
});

const userLineState = atom({
    key: 'userLineState',
    default: {},
});

const policyListState = atom({
    key: 'policyListState',
    default: [],
});

const documentListState = atom({
    key: 'documentListState',
    default: [],
});

const productTypeState = atom({
    key: 'productTypeState',
    default: 'all',
});

// new
const claimPolicyListState = atom({
    key: 'claimPolicyListState',
    default: [],
});

const policyPendingListState = atom({
    key: 'policyPendingListState',
    default: [],
});

const checkPolicyListState = atom({
    key: 'checkPolicyListState',
    default: null,
});

const policySelectedState = atom({
    key: 'policySelectedState',
    default: [],
});

const policySelectedOneState = atom({
    key: 'policySelectedOneState',
    default: null,
});

const policySelectedOneTtbTheTreasureState = atom({
    key: 'policySelectedOneTtbTheTreasureState',
    default: null,
});
const policyDetailTheTreasureState = atom({
    key: 'policyDetailTheTreasureState',
    default: null,
});


const policySelectedOnePruSecureSaverState = atom({
    key: 'policySelectedOnePruSecureSaverState',
    default: null,
});

const policyDetailPruSecureSaverState = atom({
    key: 'policyDetailPruSecureSaverState',
    default: null,
});

const costTypeListState = atom({
    key: 'costTypeListState',
    default: [],
});

const relationshipListtState = atom({
    key: 'relationshipListtState',
    default: [],
});

const bankListState = atom({
    key: 'bankListState',
    default: {},
});

const policySelectedCancelState = atom({
    key: 'policySelectedCancelState',
    default: null,
});

const policyConsentState = atom({
    key: 'policyConsentState',
    default: null,
});

const paymentState = atom({
    key: 'paymentState',
    default: {},
});
const sumaryPaymentTtbState = atom({
    key: 'sumaryPaymentTtbState',
    default: {},
});

const sumaryPaymentPruSecureSaverState = atom({
    key: 'sumaryPaymentPruSecureSaverState',
    default: {},
});

const claimListState = atom({
    key: 'claimListState',
    default: [],
});

const claimReasonState = atom({
    key: 'claimReasonState',
    default: [],
});

const claimBankListState = atom({
    key: 'claimBankListState',
    default: [],
});

const claimBankAccountState = atom({
    key: 'claimBankAccountState',
    default: null,
});

const claimHospitalState = atom({
    key: 'claimHospitalState',
    default: [],
});

const claimSicknessState = atom({
    key: 'claimSicknessState',
    default: [],
});

const accountListState = atom({
    key: 'accountListState',
    default: [],
});

const claimFormState = atom({
    key: 'claimFormState',
    default: null,
});

const payloadCheckDuplicateClaimState = atom({
    key: 'payloadCheckDuplicateClaimState',
    default: null,
});

const contactPoliciesListState = atom({
    key: 'contactPoliciesListState',
    default: [],
});

const contactFormInitialValuesState = atom({
    key: 'contactFormInitialValuesState',
    default: {},
});

const claimGYRTInsuredListState = atom({
    key: 'claimGYRTInsuredListState',
    default: [],
});

const maintenenceGlobalState = atom({
    key: 'maintenenceGlobalState',
    default: {},
});

const consentState = atom({
    key: 'consentState',
    default: {},
});

const bigRewardCampaignConsentState = atom({
    key: 'bigRewardCampaignConsentState',
    default: {
        participation: false,
        marketing: false,
        analytics: false,
    },
});

const cmsMaintenanceFlagState = atom({
    key: 'cmsMaintenanceFlagState',
    default: false,
});

const digitalPolicyState = atom({
    key: 'digitalPolicyState',
    default: {},
});

const autoDirectDebitState = atom({
    key: 'autoDirectDebitState',
    default: {
        method: '', // Use this to store the selected method (credit-card or bank-account)
        productType: '', // Use this to store the selected product type (OL or UL) [!!ONLY for bank-account method]
        policies: [], // Use this to store the list of policies fetched from the API
        consent: false, // Use this to store the consent status for the selected method,
        form: {
            cardNumber: '',
            cardName: '',
            cardType: '',
            bankName: '',
            bankOther: '',
            expireDate: '',
            relationship: true,
            creditcardCopyFile: null,
            idcardFile: null,
        },
    },
});

export {
    previousPageState,
    userState,
    userLineState,
    policyListState,
    productTypeState,
    claimPolicyListState,
    policyPendingListState,
    checkPolicyListState,
    policySelectedState,
    policySelectedOneState,
    policySelectedCancelState,
    policyConsentState,
    paymentState,
    claimListState,
    claimReasonState,
    claimBankListState,
    claimBankAccountState,
    claimSicknessState,
    claimHospitalState,
    accountListState,
    claimFormState,
    contactPoliciesListState,
    contactFormInitialValuesState,
    claimGYRTInsuredListState,
    maintenenceGlobalState,
    sumaryPaymentTtbState,
    sumaryPaymentPruSecureSaverState,
    policySelectedOneTtbTheTreasureState,
    policySelectedOnePruSecureSaverState,
    bankListState,
    policyDetailTheTreasureState,
    policyDetailPruSecureSaverState,
    costTypeListState,
    relationshipListtState,
    taxConsentState,
    consentState,
    bigRewardCampaignConsentState,
    payloadCheckDuplicateClaimState,
    cmsMaintenanceFlagState,
    documentListState,
    digitalPolicyState,
    autoDirectDebitState
};
